<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep2ogmmr.vue
*@ 컴포넌트설명 :[미얀마] 예금 상품 > 금리 안내(정기적금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
** 2022.01.17   이가영  중도해지이율 추가  
********************************************************************************/
-->

<template>
  <div>
    <div class="cont-tit">
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-22") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">MMK</th>
          <th scope="col">USD</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>6M</td>
          <td>6.50</td>
          <td>0.10</td>
        </tr>
        <tr>
          <td>12M</td>
          <td>6.70</td>
          <td>0.20</td>
        </tr>
        <tr>
          <td>24M</td>
          <td>6.90</td>
          <td>0.20</td>
        </tr>
        <tr>
          <td>36M</td>
          <td>7.10</td>
          <td>0.20</td>
        </tr>
        <tr>
          <td>48M</td>
          <td>7.30</td>
          <td>0.20</td>
        </tr>
        <tr>
          <td>60M</td>
          <td>7.50</td>
          <td>0.20</td>
        </tr>
        <tr v-if="lang == $config.LANG_KOR">
          <td>중도해지이율</td>
          <td>0.50</td>
          <td>0.00</td>
        </tr>
        <tr v-if="lang == $config.LANG_ENG">
          <td>Mid-term termination rate</td>
          <td>0.50</td>
          <td>0.00</td>
        </tr>
        <tr v-if="lang == $config.LANG_MMR">
          <td>Mid-term termination rate</td>
          <td>0.50</td>
          <td>0.00</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
  
<script>
import { mapFields } from "vuex-map-fields";
export default {
  components: {},
  data() {
    return {
      currentTab: 1,
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>